import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 所属MR一覧
 *
 * 自分が所属しているプライマリ病院の所属MR一覧を返す
 */
export class FetchUser implements APIRequest<Monitaro.FetchUserResponse> {
  response: Monitaro.FetchUserResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/users`
  }
}

/**
 * 所属MRのデータの取得
 *
 * 自分が所属しているプライマリ病院の所属MRの詳細情報を取得する
 */
export class GetUser implements APIRequest<Monitaro.GetUserResponse> {
  response: Monitaro.GetUserResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(user: string) {
    this.path = `/users/${user}`
  }
}

/**
 * 所属MRの解除
 *
 * 自分が所属しているプライマリ病院の所属MRを解除する
 */
export class DeleteUser implements APIRequest<Monitaro.DeleteUserResponse> {
  response: Monitaro.DeleteUserResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(user: string) {
    this.path = `/users/${user}`
  }
}

/**
 * 所属MRの更新
 *
 * 自分が所属しているプライマリ病院の所属MRを更新する
 */
export class PutUser implements APIRequest<Monitaro.PutUserResponse> {
  response: Monitaro.PutUserResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params?: Monitaro.UserRequest
  constructor(id: string, props: Monitaro.UserRequest) {
    this.params = props
    this.path = `/users/${id}`
  }
}
